import { render, staticRenderFns } from "./homepage-bfhs.vue?vue&type=template&id=d36e59b8&scoped=true"
import script from "./homepage-bfhs.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage-bfhs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homepage-bfhs.vue?vue&type=style&index=0&id=d36e59b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36e59b8",
  null
  
)

export default component.exports